module.exports = __webpack_public_path__ + "img/press-release.64616cfd.png";